import { revalidateSSGPage } from '@/utils';
import { getProfileQueryParams } from '@cyber-co/utils';
import {
  CreateEducationInput,
  CreateEducationResponse_Status,
  UpdateEducationInput,
  UpdateEducationResponse_Status,
  api,
  useCreateEducationMutation,
  useUpdateEducationMutation,
} from '@cyber/service/pwa';
import { toast } from '@cyberlab/uikit';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

export type TUpdateEducationParams = Omit<CreateEducationInput, 'profileId'> & {
  handle: string;
  profileId: string;
  educationId?: string;
};

export const useUpdateEducation: () => [
  updater: (p: TUpdateEducationParams) => Promise<{ isSuccess: boolean }>,
  result: any,
] = () => {
  const dispatch: any = useDispatch();

  const [updater, updateResult] = useUpdateEducationMutation();
  const [creator, createResult] = useCreateEducationMutation();

  const updateEducation = async (input: UpdateEducationInput) =>
    updater({ input }).then((data) => {
      if ('data' in data && data.data.updateEducation.status === UpdateEducationResponse_Status.Success) {
        return { isSuccess: true };
      }

      return { isSuccess: false };
    });

  const createEducation = async (input: CreateEducationInput) =>
    creator({ input }).then((data) => {
      if ('data' in data && data.data.createEducation.status === CreateEducationResponse_Status.Success) {
        return { isSuccess: true };
      }

      return { isSuccess: false };
    });

  const handleUpdate = useCallback(
    async ({ profileId, educationId, handle, ...input }: TUpdateEducationParams) => {
      const res = await (educationId
        ? updateEducation({
            educationId,
            ...input,
          })
        : createEducation({ profileId, ...input }));

      if (res.isSuccess) {
        await dispatch(api.endpoints.getProfile.initiate(getProfileQueryParams(handle), { forceRefetch: true }));

        toast.success('Update Successfully!');
        revalidateSSGPage(handle);
      }

      return res;
    },
    [updater],
  );

  return [handleUpdate, updateResult || createResult];
};
